'use client';
import { useRef, useState, useCallback, useEffect } from 'react';

const useHoverRef = (options)=>{
    const { element, timeout } = options || {};
    const timerRef = useRef(0);
    const ref = useRef(null);
    const [hovered, setHovered] = useState(false);
    const onMouseEnter = useCallback(()=>{
        if (timeout) {
            window.clearTimeout(timerRef.current);
        }
        setHovered(true);
    }, []);
    const onMouseLeave = useCallback(()=>{
        if (timeout) {
            timerRef.current = window.setTimeout(()=>setHovered(false), timeout);
        } else {
            setHovered(false);
        }
    }, []);
    useEffect(()=>{
        const current = element != null ? element : ref.current;
        if (current) {
            current.addEventListener('mouseenter', onMouseEnter);
            current.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                if (timeout) {
                    window.clearTimeout(timerRef.current);
                }
                current == null ? void 0 : current.removeEventListener('mouseenter', onMouseEnter);
                current == null ? void 0 : current.removeEventListener('mouseleave', onMouseLeave);
            };
        }
        return undefined;
    }, [
        element,
        timeout
    ]);
    return {
        ref,
        hovered
    };
};

export { useHoverRef };
//# sourceMappingURL=useHoverRef.js.map
